import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { uploadFile } from '@/lib/storage'
import { toast } from '@/lib/toast'

export function usePhotoUpload() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (file: File) => {
      const { data: { session } } = await supabase.auth.getSession()
      if (!session) throw new Error('Not authenticated')
      const ext = file.name.split('.').pop() ?? 'jpg'
      const path = `${session.user.id}/avatar.${ext}`
      await uploadFile('resident-photos', path, file, { upsert: true })
      const { error } = await supabase.from('residents').update({ photo_storage_path: path }).eq('id', session.user.id)
      if (error) throw error
      return path
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['resident-profile'] })
      toast.success('Photo updated')
    },
    onError: (err: Error) => toast.error(err.message),
  })
}
